module.exports = __webpack_public_path__ + "img/credit-card.e2c24ccd.svg";